import {
  catalogueSummary,
  useImportCsvMutation,
} from '@/features/imports/api/use-import-csv-mutation';
import { queryKeys } from '@/lib/query-keys';
import type {
  ImportServicesCsvInput,
  ImportServicesCsvResponse,
} from '@borradh-workspace/api-client/types';
import { importServicesCsvResponseSchema } from '@borradh-workspace/contracts';

export const useImportServicesCsv = (options?: {
  onSuccess?: (result: ImportServicesCsvResponse) => void;
  onError?: (error: Error) => void;
}) => {
  const { mutate, mutateAsync, isImporting, isSuccess, isError, error } =
    useImportCsvMutation<ImportServicesCsvInput, ImportServicesCsvResponse>({
      path: 'organization-services/import-csv',
      schema: importServicesCsvResponseSchema,
      event: 'services_imported_csv',
      track: (r) => ({
        imported: r.imported,
        variantsCreated: r.variantsCreated,
        staffAssigned: r.staffAssigned,
        updated: r.updated,
        skipped: r.skipped,
        rowsInFile: r.rowsInFile,
      }),
      // The import can also CREATE categories, which the services page renders
      // from its own query.
      invalidate: () => [
        queryKeys.organizationServices.all(),
        queryKeys.serviceCategories.all(),
      ],
      summarize: (r) => {
        const parts = catalogueSummary({ ...r, errors: [] });
        if (r.variantsCreated > 0) parts.push(`${r.variantsCreated} options`);
        if (r.staffAssigned > 0)
          parts.push(`${r.staffAssigned} team assignments`);
        if (r.errors.length > 0) parts.push(`${r.errors.length} failed`);
        return parts;
      },
      onSuccess: options?.onSuccess,
      onError: options?.onError,
    });
  return {
    importServicesCsv: mutate,
    importServicesCsvAsync: mutateAsync,
    isImporting,
    isSuccess,
    isError,
    error,
  };
};
